<template>
  <div>
    <input
      type="hidden"
      :name="nom"
      v-model="inputSelection"
    >
    <vue-select
      label= "TEXT"
      :options="clients"
      :disabled="disabled"
      :filterable="false"
      v-model="selection"
      @search="fetchOptions"
    />
  </div>
</template>

<script>
import vueSelect from 'vue-select'
import { getData } from '../api/client'

export default {
  components: {
    'vue-select': vueSelect
  },
  data: function () {
    return {
      clients: [],
      selection: null,
      inputSelection: ''
    }
  },
  props: {
    nom: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    initialValue: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'client'
    }
  },
  async created() {
    this.clients = await getData(this.type, '')

    for (const client of this.clients) {
      client.TEXT = this.formateAffichageClient(client)
      if (client.VAL == this.initialValue) {
        this.selection = client
      }
    }
  },
  methods: {
    formateAffichageClient(input) {
      if (this.type === 'connexion') {
        return input.LIB
      } else  {
        return input.VAL + ' (' + input.LIB + ')'
      }
    },
    async fetchOptions(search, loading) {
      loading(true)

      this.clients = await getData(this.type, search)
      for (const client of this.clients) {
        client.TEXT = this.formateAffichageClient(client)
      }

      loading(false)
    }
  },
  watch: {
    selection: function(value) {
      if (value === null) {
        this.inputSelection = ''
      } else {
        this.inputSelection = value.VAL
      }
    }
  }
}
</script>
